// extracted by mini-css-extract-plugin
export default {"shoeWeights":"fsp-shoeWeights","shoeWeight":"fsp-shoeWeight","sw_property":"fsp-sw_property"};